import { UtensilsCrossed } from "lucide-react";
import { HOME } from "@/constants/testIds";
import { IMAGES, MENUS } from "@/constants/neco";

export const Catering = () => (
  <section id="ikram" data-testid={HOME.cateringSection} className="relative py-24 md:py-32 overflow-hidden border-y border-[#D4AF37]/10">
    <div className="absolute inset-0">
      <img src={IMAGES.catering} alt="" aria-hidden="true" className="w-full h-full object-cover opacity-15" loading="lazy" />
      <div className="absolute inset-0 bg-[#121110]/85" />
    </div>

    <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
      <div className="lg:col-span-5">
        <p className="text-xs uppercase tracking-[0.35em] text-[#D4AF37]">İkram ve Hizmetler</p>
        <h2 className="font-display text-4xl sm:text-5xl tracking-tight text-[#F5F5F0] mt-5 gold-rule">
          Tadı Damakta Bırakan <span className="font-romance text-[#E5C783]">Ayrıcalıklar</span>
        </h2>
        <p className="mt-12 text-base font-light leading-relaxed text-[#B3B0A8]">
          Renk seçiminden tavan yüksekliğine, manzaralı teraslardan kişiye özel menülere kadar her
          şeyin titizlikle planlandığı yerdesiniz. İkram menülerini görmek ya da istediğiniz menüyü
          birlikte oluşturmak için bize ulaşın.
        </p>
        <div className="mt-10 bg-[#1A1817]/90 border border-[#D4AF37]/20 p-6 flex items-start gap-4">
          <UtensilsCrossed size={20} strokeWidth={1.5} className="text-[#D4AF37] shrink-0 mt-1" />
          <div>
            <p className="font-display text-xl text-[#F5F5F0]">Hayalinizdeki Menüyü Oluşturun</p>
            <p className="text-xs font-light text-[#B3B0A8] mt-2 leading-relaxed">
              Ordövr tabakları, ara sıcaklar, ana yemekler ve çorbalardan oluşan zengin seçkiyle
              kendi menünüzü oluşturabilirsiniz.
            </p>
          </div>
        </div>
      </div>

      <div className="lg:col-span-7">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-px bg-[#D4AF37]/15 border border-[#D4AF37]/15">
          {MENUS.map((m) => (
            <div key={m.name} className="bg-[#121110]/95 p-7 hover:bg-[#1A1817] transition-colors duration-500">
              <p className="font-display text-xl text-[#E5C783]">{m.name}</p>
              <p className="text-xs font-light leading-relaxed text-[#B3B0A8] mt-3">{m.items}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);
